import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import _debounce from "lodash/debounce";
import DateTimePicker from "../../../../components/DateTimePicker/DateTimePicker";
import { Form } from "semantic-ui-react";
import { catchErrors, PickerUtils } from "../../../../components/DateTimePicker";
import { DateRangeDisplay } from "../../components/DateRangeDisplay";
import { FieldHeader } from "../../components/FieldHeader";

function DateRangeWidget({
  label,
  schema,
  value,
  formContext,
}: any) {
  const { t } = useSchemaTranslation();
  const schemaFormat = (schema.format || schema.properties?.start?.format) as "date" | "time" | "date-time" || "date-time";

  let start = value.start ? catchErrors(PickerUtils.valueToDate, [value.start], undefined) : undefined;
  let end = value.end ? catchErrors(PickerUtils.valueToDate, [value.end], undefined) : undefined;

  return (
    <Form.Field>
      {label && <FieldHeader> {t(schema.title || label)} </FieldHeader>}
      {start && end ? (
        <DateRangeDisplay
          start={start}
          end={end}
          format={schemaFormat}
        />
      ) : formContext.emptyValue}
    </Form.Field>
  );
}

DateRangeWidget.defaultProps = {
  options: {
    semantic: {
      fluid: true,
      inverted: false,
    },
  },
};

DateRangeWidget.propTypes = {
  options: PropTypes.object,
};

export default DateRangeWidget